module.exports = __webpack_public_path__ + "img/messenger.3b5d6091.svg";